export default "__VITE_ASSET__DCDqmndn__"